module.exports = __webpack_public_path__ + "img/rotaryfurnace.d56645e9.svg";